import CryptoJS from 'crypto-js';

// aes128加密密钥和偏移量
const key = CryptoJS.enc.Utf8.parse('4EGJ6D9CFFA2GG9A');
const iv = CryptoJS.enc.Utf8.parse('0102030405060708');

// aes128加密
export function aES128Encrypt(text) {
  return CryptoJS.AES.encrypt(text, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
}

// aes128解密
export function aES128Decrypt(text) {
  return CryptoJS.AES.decrypt(text, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
}
